import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/practice-cta.css';

const PracticeCTA = ({ onSignIn }) => {
  const { t } = useLanguage();

  return (
    <div className="practice-cta">
      <div className="practice-cta-container">
        <div className="practice-cta-content">
          <div className="practice-cta-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
            </svg>
          </div>
          <div className="practice-cta-text">
            <h3 className="practice-cta-title">{t('practiceCTA.title')}</h3>
            <p className="practice-cta-description">{t('practiceCTA.description')}</p>
          </div>
        </div>
        <div className="practice-cta-action">
          <button onClick={onSignIn} className="practice-cta-button">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
            {t('practiceCTA.signInButton')}
          </button>
          <p className="practice-cta-hint">{t('practiceCTA.hint')}</p>
        </div>
      </div>
    </div>
  );
};

export default PracticeCTA;
